module.exports = __webpack_public_path__ + "img/邹涛.6577f4bf.jpg";